import { apiGet } from './client';

export type ApiVersion = 'v1' | 'v2';
export type ServiceVersionInfo = { id: ApiVersion; label: string; status: 'current' | 'planned'; default?: boolean };
export type ServiceInfo = { id: string; name: string; description?: string; longDescription?: string; versions: ServiceVersionInfo[] };

export async function getMeta(): Promise<{ services: ServiceInfo[]; apiVersions: ServiceVersionInfo[]; defaultApiVersion: ApiVersion }> {
  const res = await apiGet('/meta');
  const j = await res.json().catch(() => ({}));
  return {
    services: Array.isArray(j?.services) ? j.services : [],
    apiVersions: Array.isArray(j?.apiVersions) ? j.apiVersions : [],
    defaultApiVersion: j?.defaultApiVersion || 'v1',
  } as { services: ServiceInfo[]; apiVersions: ServiceVersionInfo[]; defaultApiVersion: ApiVersion };
}
